import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseWidget from "@/components/BaseWidget.vue";
import { ref } from "vue";
import { QuickformTab } from "../models/QuickformTab";
import RoundTrip from "./RoundTrip.vue";
import OneWay from "./OneWay.vue";
import MultiLeg from "./MultiLeg.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'QuickformTabs',
  setup(__props) {

const tabs: QuickformTab[] = [];

const tabIndex = ref(0);

tabs.push({
  component: RoundTrip,
  code: "RoundTrip",
  label: "Round Trip",
});

tabs.push({
  component: OneWay,
  code: "OneWay",
  label: "One Way",
});

tabs.push({
  component: MultiLeg,
  code: "MultiLeg",
  label: "Multi Leg",
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseWidget, {
    activeTabIndex: tabIndex.value,
    tabs: tabs
  }, null, 8, ["activeTabIndex"]))
}
}

})